import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import classnames from 'classnames';
import React, { forwardRef } from 'react';
import styles from "./Icon.module.js";
import { jsx as _jsx } from "react/jsx-runtime";
/**
 * @deprecated This Icon component is made for the old `@platform/icons` icons.
 * In the newer `@interhyp/platform-icons` the icons are components itself and therefore this `Icon`-Component is not needed anymore.
 * See [@interhyp/platform-icons](https://bitbucket.interhyp.de/bitbucket/projects/UI/repos/platform-sdk/browse/packages/runtime/icons)
 */
export const Icon = /*#__PURE__*/forwardRef(({
  icon,
  size = 20,
  className
}, ref) => {
  const defaultProps = {
    className: classnames(className, styles.icon),
    style: {
      width: size,
      height: size
    }
  };
  if (typeof icon === 'string') {
    return /*#__PURE__*/_jsx("i", {
      ref: ref,
      dangerouslySetInnerHTML: {
        __html: icon
      },
      ...defaultProps
    });
  }
  return /*#__PURE__*/_jsx(FontAwesomeIcon, {
    ref: ref,
    ...defaultProps,
    icon: icon
  });
});